<div
    class="avatar"
    [style.backgroundColor]="backgroundColor"
    [style.fontSize]="resolvedFontSize"
    [style.width]="resolvedDiameter"
    [style.height]="resolvedDiameter"
>
    <span>{{ initials }}</span>
</div>
